export type UpdateServiceProviderEmrConnectionResult =
    | "ok"
    | "duplicate-name"
    | "deleted"
    | "not-found";
